import { Button, Modal } from "react-bootstrap";
import React, { Dispatch, SetStateAction, useContext, useEffect, useState } from "react";
import { AppContext } from "../../../../appContext/AppContext";
import { XayDungKeHoachContext } from "../HoiChanKhamBenh";
import { Formik, Form } from "formik";
import { CODE, TYPE_WH } from "../../../../utils/Constant";
import WfButton from "../../../../workflows/components/WfButton";
import { IconButtonSave } from "../../../../component/IconSvg";
import { formatDateDTO, formatDateToDDMMYYYY } from "../../../../utils/FormatUtils";
import { TypeKeHoach } from "../models/KeHoachModel";
import ModelHeader from "../../../../component/ModelHeader";
import TableDangKyDaoTao from "../../../../quan-ly-khao-sat/Components/danh-sach-ke-hoach/components/TableDangKyDaoTao"
import DialogThemMoiDaoTao
  from "../../../../quan-ly-khao-sat/Components/danh-sach-ke-hoach/components/DialogThemMoiDaoTao";
import { TYPE_KB_CB } from "../constants/constansKeHoach";
import { generateForm, generateInitValues, generateValidationSchema } from "../../../../utils/AppFunction";
import { addPhieuKeHoach, getListCaBenh, updateListCaBenh, updatePhieuKeHoach } from "../services/services";
import { toast } from "react-toastify";

interface Props {
  show: boolean;
  onHide: () => void;
  initialValues: any;
  setInitialValues: Dispatch<SetStateAction<any>>
  type: TypeKeHoach;
}

const DialogQuanLyCaBenh = (props: Props) => {
  const { show, onHide, setInitialValues, initialValues, type } = props;
  const { setIsLoading } = useContext(AppContext);
  const { dsKeHoach, setDsKeHoach, detailPhieuKeHoach, setDetailPhieuKeHoach } = useContext(XayDungKeHoachContext);
  const [isView, setIsView] = useState<boolean>(false);
  const [listJsonGenerate, setListJsonGenerate] = useState<any>([]);
  const [initialValuesFormThemVT, setInitialValuesFormThemVT] = useState<any>({});
  const [typeDialogAddNew, setTypeDialogAddNew] = useState<any>(null);
  const [openDialogThemMoi, setOpenDialogThemMoi] = useState<boolean>(false);
  const [indexRowEdit, setIndexRowEdit] = useState<number | null>(null);
  const [dataTable, setDataTable] = useState<any>({ caseFollowUpList: [] });
  const [itemSelected, setItemSelected] = useState<any>();
  const handleFormSubmit = async (values: any) => {
    try {
      setIsLoading(true);
      const id = initialValues?.id;
      const { data } = await updateListCaBenh(id, dataTable.caseFollowUpList)
      if (CODE.SUCCESS === data?.code) {
        setIsView(true);
        toast.success("Cập nhật thành công");
      } else {
        let errorMesage = data?.data?.[0]?.message || "Xảy ra lỗi, vui lòng thử lại!";
        toast.warning(errorMesage);
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      toast.warning("Xảy ra lỗi, vui lòng thử lại!");
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleOpenDialogThemMoi = (type: any) => {
    setTypeDialogAddNew(type)
    setOpenDialogThemMoi(true);
  }

  const handleCloseDialog = () => {
    setItemSelected(null);
    setIndexRowEdit(null);
    setOpenDialogThemMoi(false);
    setTypeDialogAddNew(null)
  };

  const handleEdit = (rowData: any, index: number, typeDialog: any) => {
    setTypeDialogAddNew(typeDialog)
    setItemSelected(rowData);
    setIndexRowEdit(index);
    setOpenDialogThemMoi(true)
  }

  const hanldeDeleteRow = (index: number, typeDelete: any) => {
    const key = typeDelete?.code;
    const list = dataTable?.[key] || [];

    const newList = list.filter((x: any, i: number) => i !== index);
    setDataTable((pre: any) => ({ ...pre, [key]: newList }));
  }

  const handleAddItem = async (values: any, source?: string) => {
    const key = typeDialogAddNew?.code;
    const item = values?.[key] || {};
    const list = dataTable?.caseFollowUpList || [];

    const newList =
      indexRowEdit === null
        ? [{ ...item }, ...list]
        : list.map((x: any, i: number) => (i === indexRowEdit ? { ...item } : x));

    if (source) {
      setDataTable((pre: any) => ({ ...pre, caseFollowUpList: newList }));
    }
  };

  useEffect(() => {
    getListTable();
  }, []);

  const getListTable = async () => {
    if (!initialValues?.id) return;
    try {
      const data = await getListCaBenh(initialValues?.id)
      setDataTable({ caseFollowUpList: data?.data?.data ?? [] })
    } catch (e) {

    }
  };
  const columnsCanBo = [
    {
      name: "STT",
      field: "",
      headerStyle: {
        width: 80,
      },
      cellStyle: {
        textAlign: "center",
      },
      render: (row: any, index: number, stt: number) => stt,
    },
    ...(!isView ?
      [
        {
          name: "Thao tác",
          field: "",
          headerStyle: {
            width: 80,
          },
          cellStyle: {
            textAlign: "center",
            justifyContent: "center"
          },
          render: (row: any, index: number, stt: number) =>
            <div className="d-flex justify-content-center">
              {indexRowEdit !== index && <>
                <i
                  onClick={(e) => handleEdit(row, index, TYPE_KB_CB.CA_BENH)}
                  className="bi bi-pencil-square text-navy"
                ></i>
                <i
                  onClick={(e) => hanldeDeleteRow(index, TYPE_KB_CB.CA_BENH)}
                  className="bi bi-trash3-fill text-danger spaces ml-10  "
                ></i>
              </>}
            </div>
        },
      ] : []),
    {
      name: "Người cập nhật",
      field: "updatedByName",
      headerStyle: {},
      cellStyle: {
        textAlign: "left",
      },
      render: (row: any, index: number, stt: number) => row.updatedByName || row.item?.updatedByName || '',
    },
    {
      name: "Ngày theo dõi",
      field: "followUpDate",
      headerStyle: {
        width: 200,
      },
      cellStyle: {
        textAlign: "center",
      },
      render: (row: any, index: number, stt: number) => formatDateToDDMMYYYY(row.followUpDate || row.item?.followUpDate || ''),
    },
  ];
  return (
    <Modal
      centered
      show={show}
      // onHide={onHide}
      size="xl"
      fullscreen
      className="page-full spaces h-calc-vh-50 dialog-coso-kb-cb"
    >
      <Formik
        enableReinitialize
        validateOnChange={true}
        validateOnBlur={true}
        initialValues={{ [type.formThongTinChung]: initialValues }}
        validationSchema={null}
        onSubmit={handleFormSubmit}
      >
        {({ values, touched, errors, setValues, handleChange, handleSubmit, setFieldValue }) => (
          <Form onSubmit={handleSubmit}>
            <ModelHeader onHide={onHide} title={type.name} />
            <Modal.Body className="spaces p-0 bg-white">
              <div className="spaces px-10">
                <TableDangKyDaoTao
                  columns={columnsCanBo}
                  title={"Theo dõi ca bệnh"}
                  isView={isView}
                  setInitialValuesFormThemVT={setInitialValuesFormThemVT}
                  setOpenDialog={handleOpenDialogThemMoi}
                  dsItems={dataTable?.caseFollowUpList ?? []}
                  type={TYPE_KB_CB.CA_BENH}
                />
              </div>
            </Modal.Body>
            <div className="bottom-button d-flex justify-content-start w-100 bg-white spaces py-6 pl-5">
              {(values.keHoach?.id || detailPhieuKeHoach?.id) && !detailPhieuKeHoach?.isView && (
                <WfButton
                  additionalFunc={(data: any) => {
                    setDetailPhieuKeHoach({
                      ...detailPhieuKeHoach,
                      status: data?.currCode,
                      statusCode: data?.currCode,
                      statusId: data?.currId,
                    })
                  }}
                  afterSubmit={() => {
                    handleFormSubmit(values)
                  }}
                  handleClick={(data: any) => {
                    data.code === "approved_done" && setIsView(true);
                  }}
                  tracker={type.trackerCode}
                  onHide={onHide}
                  objectId={values.keHoach?.id || detailPhieuKeHoach?.id}
                />
              )}
              {!isView &&
                <Button type="submit" className="btn btn-fill min-w-120px spaces mx-3">
                  <IconButtonSave /> Lưu
                </Button>
              }
            </div>
          </Form>
        )}
      </Formik>

      {openDialogThemMoi && typeDialogAddNew &&
        <DialogThemMoiDaoTao
          onOk={handleAddItem}
          show={openDialogThemMoi}
          onHide={handleCloseDialog}
          initialValues={{
            [typeDialogAddNew.code]: {
              ...itemSelected,
              id: indexRowEdit === null ? null : Math.random().toString(36).substring(0, 10),
            }
          }}
          type={typeDialogAddNew}
        />
      }
    </Modal>
  );
};

export default DialogQuanLyCaBenh;
